export const environment = {
  production: true,
  apiUrl: 'https://api.distribuidorasc.com.br/',
  frontUrl: 'https://distribuidorasc.com.br/',
  linkImages: 'https://midias.distribuidorasc.com.br/imagens/produtos/',
  linkBrands: 'https://midias.distribuidorasc.com.br/imagens/marcas/',
};
